// extracted by mini-css-extract-plugin
export var countryCode = "DoubleScreenPopupWithMobileAndCouponCode-module--countryCode--P5jCL";
export var coupon = "DoubleScreenPopupWithMobileAndCouponCode-module--coupon--+qlbo";
export var cross = "DoubleScreenPopupWithMobileAndCouponCode-module--cross--CuDtN";
export var customFont = "DoubleScreenPopupWithMobileAndCouponCode-module--customFont--9V8Y6";
export var email = "DoubleScreenPopupWithMobileAndCouponCode-module--email--LuqnZ";
export var modal = "DoubleScreenPopupWithMobileAndCouponCode-module--modal--ppJw5";